import { useQuery } from '@tanstack/react-query';
import { fetchProducts } from '../services/productService';

/**
 * @typedef {Object} SortConfig
 * @property {string} field - Key of Product to sort by
 * @property {'asc' | 'desc'} direction - Sort direction
 */

/**
 * Hook for fetching products with filters and sorting
 * @param {import('../types').ProductFilter} filters - Filters to apply
 * @param {SortConfig} [sort] - Optional sorting configuration
 * @returns {import('@tanstack/react-query').UseQueryResult<import('../types').Product[], Error>}
 */
export function useProducts(filters, sort) {
  return useQuery({
    queryKey: ['products', filters, sort],
    queryFn: () => fetchProducts(filters, sort),
  });
} 